import { jsx as _jsx } from "react/jsx-runtime";
function SvgArrowDDownIcon(props) {
    return (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M11.2537 17.6339C11.6518 18.1224 12.3514 18.1223 12.7494 17.6338L20.7455 7.81665C21.3188 7.11273 20.8607 6.00025 19.9976 6.00025L4.00243 6.00024C3.13917 6.00024 2.68115 7.11293 3.25467 7.8168L11.2537 17.6339Z", fill: "currentColor" }, void 0) }), void 0));
}
export default SvgArrowDDownIcon;
